import { CSS, styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { Switch as SwitchPrimitive } from "radix-ui";
import { useContext } from "react";
import { FieldContext } from "./Field";

export type SwitchProps = SwitchPrimitive.SwitchProps & {
  indeterminate?: boolean;
  css?: CSS;
  size?: "xs" | "sm" | "md";
};

export function Switch({ indeterminate, size = "md", ...props }: SwitchProps) {
  const { inputProps } = useContext(FieldContext);
  const { size: uselessSize, ...realInputProps } = inputProps;
  return (
    <Root data-indeterminate={indeterminate ? "" : undefined} size={size} {...realInputProps} {...props}>
      <Thumb data-indeterminate={indeterminate ? "" : undefined} size={size}></Thumb>
    </Root>
  );
}

const Root = styled(SwitchPrimitive.Root, {
  position: "relative",
  borderRadius: 16,
  backgroundColor: colors.warmGrey,
  overflow: "hidden",
  transition: "background-color 100ms",
  "&[data-state=checked]": {
    backgroundColor: colors.cyan,
    color: colors.navy,
  },
  "&[data-indeterminate]": {
    backgroundColor: colors.gray,
    color: colors.text2,
  },
  variants: {
    size: {
      xs: {
        h: 20,
        w: 44,
      },
      sm: {
        h: 24,
        w: 54,
      },
      md: {
        width: 64,
        height: 28,
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});
const Thumb = styled(SwitchPrimitive.Thumb, {
  position: "absolute",
  borderRadius: 9999,
  d: "flex",
  items: "center",
  justify: "center",

  backgroundColor: colors.white,
  boxShadow: `0 3px 0.5px rgba(0, 0, 0, 0.06), 0 3px 4px rgba(0, 0, 0, 0.15)`,
  transform: "translateX(0px)",
  transition: "transform 100ms",
  willChange: "transform",
  variants: {
    size: {
      xs: {
        width: 26,
        height: 16,
        top: 2,
        left: 2,
        "&[data-state=checked]": {
          transform: "translateX(14px)",
        },
        "&[data-indeterminate]": {
          transform: "translateX(7px)",
        },
      },
      sm: {
        width: 32,
        height: 20,
        top: 2,
        left: 2,
        "&[data-state=checked]": {
          transform: "translateX(18px)",
        },
        "&[data-indeterminate]": {
          transform: "translateX(9px)",
        },
      },
      md: {
        width: 38,
        height: 24,
        top: 2,
        left: 2,
        "&[data-state=checked]": {
          transform: "translateX(22px)",
        },
        "&[data-indeterminate]": {
          transform: "translateX(11px)",
        },
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});
